// extracted by mini-css-extract-plugin
export default {"Title":"ActivityConfiguration_Title__7FxJ1","Row":"ActivityConfiguration_Row__EkUCC"};